import styled, { css } from 'styled-components'
import { colors, fonts } from 'modules/dashboard/Home/Dashboard.global.styles'
import { phoneMaxWidth, fontSize } from '../../../../DashboardSettings.styles'
import IconButton from 'components/UI/Button/IconButton'

export const Wrapper = styled.div`
  width: 220px;
  margin-left: 160px;

  @media (max-width: 900px) {
    margin-left: 40px;
  }
  
  @media (max-width: ${phoneMaxWidth}px) {
    margin: auto;
    margin-bottom: 20px;
  }
`

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const StyledIconButton = styled(IconButton)`
  margin-right: -15px;
`
